function normalizeHeaderName(header) {
  return String(header || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, " ")
    .trim();
}

function autoMatchHeader(headers, possibleMatches, used = new Set()) {
  if (!Array.isArray(headers) || !headers.length) return "";

  const normalizedUsed = new Set(
    Array.from(used || [])
      .map((value) => normalizeHeaderName(value))
      .filter(Boolean)
  );

  const uniqueCandidates = [...new Set(
    (possibleMatches || [])
      .map((value) => normalizeHeaderName(value))
      .filter(Boolean)
      .filter((value) => value.length > 0)
  )].sort((a, b) => b.length - a.length);

  for (const candidate of uniqueCandidates) {
    for (const header of headers) {
      const normalizedHeader = normalizeHeaderName(header);
      if (!normalizedHeader || normalizedUsed.has(normalizedHeader)) continue;

      if (normalizedHeader === candidate) {
        return header;
      }
    }

    for (const header of headers) {
      const normalizedHeader = normalizeHeaderName(header);
      if (!normalizedHeader || normalizedUsed.has(normalizedHeader)) continue;

      if (normalizedHeader.includes(candidate) || candidate.includes(normalizedHeader)) {
        return header;
      }
    }
  }

  return "";
}

module.exports = {
  normalizeHeaderName,
  autoMatchHeader,
};
